import React from "react";
import Header  from "./page/Header";
import Heading from "./page/Heading";
import Service from "./page/Service";
import Feacher from "./page/Feacher";
import About from "./page/About";
import Contact from "./page/Contact";
import Footer from "./page/Footer";

function App() {
  return (
    <>
   <Header />
   <Heading />
   <Service />
   <Feacher />
   <About />
   <Contact />
   <Footer />
    </>
  );
}

export default App;
